// extracted by mini-css-extract-plugin
export var dropdownButton = "_3u-0";
export var fullWidthDropdownButton = "_3u-1";
export var icon = "_3u-3";
export var iconPlaceholder = "_3u-2";
export var menuItemRow = "_3u-8";
export var separator = "_3u-c";
export var shortcutContainer = "_3u-7";
export var shortcutIconLg = "_3u-6";
export var shortcutIconMd = "_3u-5";
export var shortcutIconSm = "_3u-4";
export var submenuChevron = "_3u-b";
export var submenuDropdown = "_3u-9";
export var submenuTriggerRow = "_3u-a";